import {
  activeChatbotSelector,
  connectedPageSelector,
  getFbPageIdSelector,
} from '@mm/state/selectors/viewSelectors';
import { StoreState } from '@mm/state/store-interfaces';

export const mapFormStateToProps = (state: StoreState) => {
  const bot = activeChatbotSelector(state);
  const guards = state.promoter.entities;

  return {
    bot,
    connectedPage: connectedPageSelector(state),
    chatbotId: bot.id,
    guards,
    pages: state.page.entities,
    pageGroups: state.pageGroup.entities,
    attributes: state.attribute.entities,
    promoter: state.promoter,
    fbAppId: state.env.fbAppId,
    fbPageId: getFbPageIdSelector(state),
  };
};

export const mapDropdownStateToProps = state => ({
  posts: state.fbPost.entities,
});
